import { render } from "./desktop2.vue?vue&type=template&id=5fe210a8"
import script from "./desktop2.vue?vue&type=script&lang=js"
export * from "./desktop2.vue?vue&type=script&lang=js"

import "./desktop2.vue?vue&type=style&index=0&id=5fe210a8&lang=scss"

import exportComponent from "../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__